import { render, staticRenderFns } from "./PLoginPage.vue?vue&type=template&id=f474372e&"
import script from "./PLoginPage.vue?vue&type=script&lang=ts&"
export * from "./PLoginPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports